import type { GraphpadWidgetConfig } from '../graphpad.model';

/**
 * Preset for testing fixedAxis: 'y' — Y range is preserved, X adjusts.
 * Grid squares should be square; y=x should appear at 45° in a non-square container.
 */
export const TEST_FIXED_AXIS_Y_PRESET: GraphpadWidgetConfig = {
  id: 'test-fixed-axis-y',
  type: 'graphpad',
  params: {
    f: {
      type: 'linear',
      params: { m: 1, b: 0 },
    },
    'line-h': {
      type: 'line',
      params: {
        from: { x: -8, y: 2 },
        to: { x: 8, y: 2 },
        name: 'horizontal',
      },
    },
    'line-v': {
      type: 'line',
      params: {
        from: { x: 3, y: -8 },
        to: { x: 3, y: 8 },
        name: 'vertical',
      },
    },
  },
  display: {
    canvas: { color: 'neutral-0' },
    coordinateSystem: {
      boundingbox: { xStart: -10, xEnd: 10, yStart: -10, yEnd: 10 },
      fixedAxis: 'y',
      grid: { type: 'lines', visible: true },
    },
    elements: {
      f: {
        curve: { color: 'sky' },
      },
      'line-h': {
        line: { color: 'green' },
      },
      'line-v': {
        line: { color: 'pink' },
      },
    },
  },
};

/**
 * Preset for testing fixedAxis: 'x' — X range is preserved, Y adjusts.
 */
export const TEST_FIXED_AXIS_X_PRESET: GraphpadWidgetConfig = {
  id: 'test-fixed-axis-x',
  type: 'graphpad',
  params: {
    f: {
      type: 'linear',
      params: { m: 1, b: 0 },
    },
    'line-h': {
      type: 'line',
      params: {
        from: { x: -8, y: 2 },
        to: { x: 8, y: 2 },
        name: 'horizontal',
      },
    },
    'line-v': {
      type: 'line',
      params: {
        from: { x: 3, y: -8 },
        to: { x: 3, y: 8 },
        name: 'vertical',
      },
    },
  },
  display: {
    canvas: { color: 'neutral-0' },
    coordinateSystem: {
      boundingbox: { xStart: -10, xEnd: 10, yStart: -10, yEnd: 10 },
      fixedAxis: 'x',
      grid: { type: 'lines', visible: true },
    },
    elements: {
      f: {
        curve: { color: 'sky' },
      },
      'line-h': {
        line: { color: 'green' },
      },
      'line-v': {
        line: { color: 'pink' },
      },
    },
  },
};
